import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { TrustSection } from '../components/TrustSection';
import { ProductCategories } from '../components/ProductCategories';
import { IndustriesSection } from '../components/IndustriesSection';
import { HeritageSection } from '../components/HeritageSection';
import { FloatingReview } from '../components/FloatingReview';
import { Footer } from '../components/Footer';
export function HomePage() {
  useEffect(() => {
    document.title = 'Industrial Labels & Nameplates | UK Manufacturer';
  }, []);
  return <div className="min-h-screen bg-white font-sans text-[#0A1628] selection:bg-[#0052CC] selection:text-white overflow-x-hidden" data-id="element-434">
      <Header data-id="element-435" />
      <main className="pt-[135px] md:pt-[145px]" data-id="element-436">
        <Hero data-id="element-437" />

        <TrustSection data-id="element-438" />

        <ProductCategories data-id="element-439" />

        <IndustriesSection data-id="element-440" />

        <HeritageSection data-id="element-441" />
      </main>
      <Footer data-id="element-442" />
      <FloatingReview data-id="element-443" />
    </div>;
}